// Shared by the order form and the order API, so both enforce the same limits.
export const MAX_QUANTITY_PER_ITEM = 20
export const MAX_ITEMS_PER_ORDER = 60
